var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShuffleWhiteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 99",
    fill: "#5300f2",
    stroke: "#5300f2",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.375,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 468"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 864",
    d: "M9.455 18.19H8.001a.513.513 0 100 1.026h1.454a3.978 3.978 0 002.925-1.3l1.676-1.864 1.676 1.864a3.978 3.978 0 002.925 1.3h.616l-.889.941a.511.511 0 00.017.718.552.552 0 00.359.137.531.531 0 00.376-.154l2.018-2.155-2.018-2.155a.508.508 0 00-.735.7l.889.941h-.616a2.94 2.94 0 01-2.155-.958l-1.779-1.95 1.744-1.95a2.878 2.878 0 012.155-.958h.616l-.889.941a.511.511 0 00.017.718.552.552 0 00.359.137.531.531 0 00.376-.154l2.035-2.155-2.018-2.155a.508.508 0 10-.735.7l.889.941h-.616a3.978 3.978 0 00-2.925 1.3l-1.693 1.864-1.676-1.864a3.978 3.978 0 00-2.925-1.3H8.001a.513.513 0 100 1.026h1.454a2.94 2.94 0 012.155.958l1.762 1.95-1.762 1.95a2.94 2.94 0 01-2.155.96z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffleWhiteIcon);
export default __webpack_public_path__ + "static/media/shuffle-white-icon.c04bbb0c5a7379313c35543fbb736fe7.svg";
export { ForwardRef as ReactComponent };